import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() page = 0;
  @Input() size = 0;
  @Input() totalElements = 0;

  @Output() pageSelected = new EventEmitter<number>();
  @Output() sizeSelected = new EventEmitter<number>();

  public readonly pageSizes = [
    5,
    10,
    25,
    50,
    100
  ];

  constructor() { }

  onPageSelect(page) { this.pageSelected.emit(page); }
  onSizeSelect(size) { this.sizeSelected.emit(size); }
}
